import React from 'react';
import styles from './administrator-mini-card.module.scss';
import { ICardAdministratorInfo } from './administrator-mini-card.interface';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { CircleImage } from '../circle-image/circle-image';

export interface IAdministratorMiniCardProps {
  administratorInfo: ICardAdministratorInfo;
}

export const AdministratorMiniCard: React.FC<IAdministratorMiniCardProps> = ({
  administratorInfo,
}) => {
  const navigate = useNavigate();

  const handleNavigateClick = () => {
    const path = AppLinks.AdministratorLink.replace(
      ':id',
      String(administratorInfo.id)
    );
    navigate(path);
  };
  return (
    <div className={styles.admin_card__container} onClick={handleNavigateClick}>
      <div className={styles.admin__title}>
        <CircleImage imgSize={35} imgSrc={administratorInfo.imgUrl} />
        <div className={styles.title__name}>{administratorInfo.fio}</div>
      </div>
    </div>
  );
};
